import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { authService } from '@/services';
import { isAuthenticatedAtom, currentUserAtom } from './use-auth';
import type { UserAccountDto } from '@/types';

const userAccountsAtom = atomWithQuery((get) => ({
  queryKey: ['auth', 'user-accounts'],
  queryFn: authService.getUserAccounts,
  staleTime: 5 * 60 * 1000,
  enabled: get(isAuthenticatedAtom),
}));

export const useUserAccounts = () => {
  const [{ data, isLoading, isError }] = useAtom(userAccountsAtom);
  const [currentUser] = useAtom(currentUserAtom);

  const accounts = (data?.accounts ?? []) as UserAccountDto[];
  const currentAccountId =
    currentUser?.accountId != null
      ? Number(currentUser.accountId)
      : (data?.currentAccountId ?? null);

  return { accounts, currentAccountId, isLoading, isError };
};
